import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClosedPlans from './pages/ClosedPlans';
import OpenPlans from './pages/OpenPlans';
import PlanDetails from './pages/PlanDetails';
import TimeControl from './pages/TimeControl';
import LogisticsPlans from './pages/LogisticsPlans';
import LogisticsDetail from './pages/LogisticsDetail';
import Calendar from './pages/Calendar';

export const routes = [
	{
		path: '/',
		component: <Dashboard />,
		exact: true
	},
	{
		path: '/time-control',
		component: <TimeControl />
	},
	{
		path: '/calendar',
		component: <Calendar />
	},
	{
		path: '/open-plans',
		component: <OpenPlans />
	},
	{
		path: '/plan-details/:id',
		component: <PlanDetails />
	},
	{
		path: '/closed-plans',
		component: <ClosedPlans />
	},
	{
		path: '/logistics-plans/:status',
		component: <LogisticsPlans />
	},
	{
		path: '/logistics-detail/:id',
		component: <LogisticsDetail />
	},
	{
		path: '/login',
		component: <Login />
	},
]
